import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from "../../../../i18next";

import {
    loadAllTenderTypes,
    loadInStoreSettings,
    updateInStoreSettings,
    resetInStoreSettings,
    resetTenderTypes,
    getPaymentSettings, 
    getAllRestaurantMenus 
} from '../../../../actions/index';
import ServiceSettings from './ServiceSettings';
import { getCurrencySymbol } from "../../../../utils/CommonUtils";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';

class InStoreScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsData: [],
            theme: null,
            primaryColor: null
        }

        this.updateInStoreSettings = this.updateInStoreSettings.bind(this);
    }

    componentDidMount() {
        const { role } = this.props.currentlyLoggedInUser;
        this.props.loadAllTenderTypes();
        const restaurantId = this.props.match.params.id;
        this.props.loadInStoreSettings(restaurantId);
        // Response and callback are used to prepopulate payment types
        if (role === MENUU_MASTER_ADMIN) {
            this.props.getPaymentSettings(restaurantId);
        }
        this.props.getAllRestaurantMenus(restaurantId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.inStoreSettings !== prevProps.inStoreSettings) {
            // console.log('inStoreSettings didUPDATE ', this.props.inStoreSettings)
            this.setState({
                settingsData: this.props.inStoreSettings
            });
        }

        if (this.props.restaurant !== prevProps.restaurant) {   
            this.setState({
                ...this.state,
                theme: this.props.restaurant.chain.customerFrontEndTheme ? this.props.restaurant.chain.customerFrontEndTheme.type : '',
                primaryColor: this.props.restaurant.chain.customerFrontEndTheme ? this.props.restaurant.chain.customerFrontEndTheme.primaryColor : ''
            });
        }
    }

    componentWillUnmount() {
        this.props.resetInStoreSettings();
        this.props.resetTenderTypes();
    }

    updateInStoreSettings(settings, callback) {
        const restaurantId = this.props.match.params.id;
        this.props.updateInStoreSettings(restaurantId, settings, callback);
    }

    render() {
        const deliveryTranslation = i18n.t('common:deliveryCollectionDineInCurbside.operationHoursCollection');
        const currency = getCurrencySymbol(this.props.restaurant.currency);

        return (
            <ServiceSettings
                settings={this.props.inStoreSettings}
                prepopulatedSettings={this.state.settingsData}
                updateSettings={this.updateInStoreSettings}
                tenderTypes={this.props.tenderTypes}
                translationPhrase={deliveryTranslation}
                currency={currency}
                isInStore={true}
                restaurantId={this.props.match.params.id}
                theme={this.state.theme}
                primaryColor={this.state.primaryColor}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        inStoreSettings: state.inStoreSettings,
        tenderTypes: state.tenderTypes,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user
    }
}

export default connect(mapStateToProps, {
    loadAllTenderTypes,
    loadInStoreSettings,
    updateInStoreSettings,
    resetInStoreSettings,
    resetTenderTypes,
    getPaymentSettings,
    getAllRestaurantMenus 
})(InStoreScreen);



// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/InStoreScreen.js